import script from "./LoginNew.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginNew.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__